<template>
  <v-footer class="white">
    <footer>
      <div id="sns" class="column">
        <div class="sns">
          <ul class="sns_inner_ul">
            <li class="sns_inner_li" v-ripple>
              <span class="snsbutton fade">
                <!-- twitter -->
                <a
                  href="http://twitter.com/share?&url=http://d-mebius.com/toho_w_p/"
                  rel="nofollow"
                >
                  <picture>
                    <souce
                      srcset="../assets/icon_twitter.webp"
                      type="image/webp"
                      width="64"
                      height="64"
                    />
                    <img
                      src="../assets/icon_twitter.png"
                      alt="ツイート"
                      width="64"
                      height="64"
                    />
                  </picture>
                </a>
              </span>
            </li>
            <li class="sns_inner_li" v-ripple>
              <span class="snsbutton">
                <!-- facebook -->

                <a
                  href="http://www.facebook.com/share.php?u=http://d-mebius.com/toho_w_p/"
                  onclick="window.open(encodeURI(decodeURI(this.href)), 'FBwindow', 'width=554, height=470, menubar=no, toolbar=no, scrollbars=yes'); return false;"
                  rel="nofollow"
                >
                  <picture>
                    <souce
                      srcset="../assets/icon_fb.webp"
                      type="image/webp"
                      width="64"
                      height="64"
                    />
                    <img src="../assets/icon_fb.png" width="64" height="64" />
                  </picture>
                </a>
              </span>
            </li>
          </ul>
          <!-- end .sns -->
        </div>
      </div>
      <div class="copyright">
        <div class="logo">
          <picture class="ma-5">
            <souce
              srcset="../assets/icon_switch.webp"
              type="image/webp"
              width="64"
              height="64"
            />
            <img src="../assets/icon_switch.png" width="64" height="64" />
          </picture>
          <div v-ripple>
            <a href="https://www16.big.or.jp/~zun/">
              <picture class="ma-5">
                <img src="../assets/banner.gif" width="200" height="40" />
              </picture>
            </a>
          </div>
          <div v-ripple>
            <a href="http://d-mebius.com/">
              <picture class="ma-5">
                <source
                  srcset="../assets/logo_mebius.webp"
                  type="image/webp"
                  width="175"
                  height="43"
                />
                <img src="../assets/logo_mebius.png" width="175" height="43" />
              </picture>
            </a>
          </div>
          <div v-ripple>
            <a href="http://playdoujin.mediascape.co.jp/">
              <picture class="ma-5">
                <source
                  srcset="../assets/logo_playdojin.webp"
                  type="image/webp"
                  width="170"
                  height="47"
                />
                <img
                  src="../assets/logo_playdojin.png"
                  width="170"
                  height="47"
                />
              </picture>
            </a>
          </div>
          <div>
            <picture class="ma-5">
              <source
                srcset="../assets/logo_hachikuma.webp"
                type="image/webp"
                width="182"
                height="39"
              />
              <img src="../assets/logo_hachikuma.png" width="182" height="39" />
            </picture>
          </div>
        </div>
        <div class="ma-auto text-center">
          <p>※画面は開発中のものです。</p>
          <p>
            &copy;上海アリス幻樂団 &copy;2016-2023 Mediascape Co.,Ltd. /<br />
            &copy;Hachikumasoft. Published by mebius.
          </p>
          <p>
            ※「東方蒼神縁起V」「東方幻想魔録W」は東方Projectの二次創作作品です。<br />
            東方Projectの著作権は上海アリス幻樂団にあります。
          </p>
        </div>
      </div>
    </footer>
  </v-footer>
</template>

<style scoped>
  #sns {
    margin: 50px auto;
  }
  .sns_inner_ul {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    margin: 20px auto;
  }
  .sns_inner_li {
    margin: 2px;
    width: 64px;
    height: 64px;
    position: relative;
    z-index: 0;
    display: block;
    overflow: hidden;
  }

  footer {
    width: 100%;
    display: block;
    position: relative;
    padding-top: 50px;
  }
  .logo {
    margin: 0 auto;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    flex-flow: wrap;
    padding-bottom: 20px;
  }
</style>
